import { commonShortNouns } from "./common-short-fields";

export const platformAdminApplications = {
  title: "業務入口",
  subtitle: "業務入口の状態、ポータル遷移先、接続状態を管理します。",
  summaryTotal: "入口総数: {count}",
  summaryOnline: "オンライン: {count}",
  summaryDegraded: "低下: {count}",
  summaryOffline: "オフライン: {count}",
  summaryUnknown: "不明: {count}",
  summaryPlanning: "計画中: {count}",
  summaryDraft: "下書き接続: {count}",
  summaryOnboarding: "接続中: {count}",
  summaryInvalidated: "失効トリガー: {count}",
  summaryWarning: "警告入口: {count}",
  summaryCritical: "重大入口: {count}",
  summaryRemediation: "要是正入口: {count}",
  summaryRemediationCritical: "高優先是正: {count}",
  tableTitle: "業務入口一覧",
  tableSubtitle: "試験業務と靶場業務の統一入口一覧です。",
  searchPlaceholder: "入口 / ドメイン / 説明で検索",
  filterAll: "すべて {count}",
  filterOnline: "オンライン {count}",
  filterDegraded: "低下 {count}",
  filterOffline: "オフライン {count}",
  filterUnknown: "不明 {count}",
  drawerTitle: "{name} ・ 状態詳細",
  providerStatusTitle: "基盤依存関係",
  accessControlTitle: "認証接続状態",
  invalidationTitle: "失効ポリシー",
  remediationTitle: "是正提案",
  providerModeLabel: "モード: {value}",
  providerPhaseLabel: "フェーズ: {value}",
  providerDependenciesLabel: "依存先: {value}",
  accessConfigured: "設定済み",
  accessMissing: "未設定",
  accessRiskHealthy: "問題なし",
  accessRiskExpired: "期限切れ: {count}",
  accessRiskExpiringSoon: "まもなく期限切れ: {count}",
  accessFields: {
    state: "接続状態",
    applicationStatus: "入口状態",
    rule: "適用ルール",
    ruleDescription: "ルール説明",
    reasons: "状態理由",
    grants: "アクセス付与",
    roleMappings: "ロールマッピング",
    activeCredentials: "有効資格情報",
    credentialRisk: "資格情報リスク",
  },
  invalidationFields: {
    triggers: "トリガー条件",
    effects: "適用結果",
    warningDays: "警告日数",
    severity: "重大度",
  },
  remediationFields: {
    priority: "是正優先度",
    reasons: "是正理由",
    actions: "推奨アクション",
  },
  authConfigAction: "ログイン方式設定",
  authConfigTitle: "{name} ・ ログイン方式設定",
  authConfigTitleShort: "ログイン方式設定",
  authConfigExamAdmin: "管理端ログイン方式",
  authConfigCandidate: "受験者ログイン方式",
  authConfigEntryModes: "入口ログイン方式上書き",
  authConfigAddEntryMode: "入口設定を追加",
  authConfigEntryKey: "入口キー",
  authConfigEntryKeyPlaceholder: "例: exam_admin / candidate / user / operator",
  authConfigEntryMode: "入口ログイン方式",
  authConfigSaved: "ログイン方式設定を保存しました",
  severities: {
    normal: "正常",
    warning: "警告",
    critical: "重大",
  },
  accessStates: {
    draft: "下書き",
    onboarding: "接続中",
    active: "有効",
    degraded: "低下",
    blocked: "遮断",
    revoked: "失効",
  },
  undefinedAccessState: "未定義の接続状態",
  accessReasons: {
    missing_access_configuration: "接続設定が不足",
    missing_active_credentials: "有効な資格情報が不足",
    credentials_expired: "期限切れ資格情報あり",
    credentials_expiring_soon: "まもなく期限切れの資格情報あり",
    application_status_not_active: "アプリ状態が active ではない",
    all_credentials_revoked: "資格情報がすべて失効",
  },
  undefinedAccessReason: "未定義の接続理由",
  invalidationEffects: {
    none: "失効なし",
    degraded_access: "降格アクセス",
    blocked_access: "遮断アクセス",
    revoked_access: "撤回アクセス",
  },
  undefinedInvalidationEffect: "未定義の失効影響",
  remediationActions: {
    none: "是正不要",
    configure_access_grants: "アクセス権限を補完",
    configure_role_mappings: "ロールマッピングを補完",
    issue_active_credentials: "有効な資格情報を発行",
    rotate_expiring_credentials: "期限接近資格情報をローテーション",
    replace_expired_credentials: "期限切れ資格情報を置換",
    reactivate_application: "アプリ状態を復帰",
  },
  undefinedRemediationAction: "未定義の是正アクション",
  fields: {
    name: "アプリ名",
    status: "稼働状態",
    domain: "ドメイン",
    endpoint: "入口 URL",
    note: "業務説明",
  },
  table: {
    app: "アプリ",
    domain: "ドメイン",
    note: "業務説明",
    status: commonShortNouns.status,
    latency: "遅延",
    actions: commonShortNouns.actions,
  },
} as const;
